module.exports = __webpack_public_path__ + "img/23-s.34bc4a04.png";